export default __webpack_public_path__ + "static/media/icon-bubble-ok.80da654c.svg";